import React from 'react';
import LateralMenu from '../LateralMenu';
import { faCalendar, faGear, faKey, faLock, faNoteSticky, faTicket } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';

export default function UserLateralMenu({ navigation, open, authenticatedUser, setOpen, selectedMenu }: LateralMenuProps) {
    const items = [];

    items.push({
        icon: faGear,
        text: translate('account'),
        action: () => navigation.navigate('User', { screen: 'Account' }),
        selected: selectedMenu == 'account'
    });
    items.push({
        icon: faKey,
        text: translate('changePassword'),
        action: () => navigation.navigate('User', { screen: 'Password' }),
        selected: selectedMenu == 'password'
    });
    items.push({
        icon: faLock,
        text: translate('sessions'),
        action: () => navigation.navigate('User', { screen: 'Sessions' }),
        selected: selectedMenu == 'sessions'
    });
    items.push({
        icon: faCalendar,
        text: translate('calendar'),
        action: () => navigation.navigate('User', { screen: 'Calendar' }),
        selected: selectedMenu == 'calendar'
    });
    items.push({
        icon: faNoteSticky,
        text: translate('notes'),
        action: () => navigation.navigate('User', { screen: 'Notes' }),
        selected: selectedMenu == 'notes'
    });

    if (authenticatedUser?.permissions.create_support_ticket || authenticatedUser?.permissions.manage_support_tickets) {
        items.push({
            icon: faTicket,
            text: translate('myTicket'),
            action: () => navigation.navigate('User', { screen: 'OwnSupportTickets' }),
            selected: selectedMenu == 'support-tickets'
        });
    }

    return (
        <LateralMenu
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={items}
        />
    );
}
